<template>
  <div class="lock_screen_container p-3">
    <div class="form_container">
      <div class="d-flex justify-content-center mb-2">
        <img src="@/assets/img/logo.png" class="img-fluid" width="150" alt="logo-white" title="logo-white" />
      </div>
      <div class="text-center mb-3">
        <span class="fnt-15 fw-bold">Welcome back, {{ user?.name }}!</span>
      </div>
      <div class="mb-3">
        <button @click="$emit('unlock')" class="btn btn-submit w-100">Unlock</button>
      </div>

      <div class="text-center">Not you? <a @click.prevent="handleSignOutUser" class="clr-red-froly" href="javascript:void(0)">Sign out</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LockScreen",
  methods: {
    handleSignOutUser() {
      this.$store.dispatch("auth/logoutUser");
    }
  }
};
</script>

<style scoped lang="scss">
.lock_screen_container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--body-background-color);
  z-index: 1000;
}

.lock-screen-content {
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}
</style>